import React from "react";
import { ShiftThresholds, TimesheetsShiftInfo } from "../../../types/Shift.types";
import { AuditTimestampPairDisplay } from "./AuditTimestampPairDisplay";
import { AuditSection } from "./AuditSection";
import { TimestampRow } from "./styledComponents";
import { getEditAuthor, getEditDate, getEditLabel } from "./utils";
import { useAuditHistoryItems } from "./useAuditHistoryItems";
import { TransformedPair } from "./types";

const clockInOutIcon = "/public/images/icons/Timesheets/clock-in-out-timer.svg";

export type AuditClockInOutSectionProps = {
  clockInOutEdits: TransformedPair[];
  timezone: string;
  shiftThresholds: ShiftThresholds;
  shiftKey: string;
  shiftInfo: TimesheetsShiftInfo;
};

/**
 * Displays the clock in/out audit history section.
 * Shows the most recent edit with option to expand history.
 */
export const AuditClockInOutSection = ({
  clockInOutEdits,
  timezone,
  shiftThresholds,
  shiftKey,
  shiftInfo,
}: AuditClockInOutSectionProps) => {
  const latestEdit = clockInOutEdits[0];
  const historicalEdits = clockInOutEdits.slice(1);

  const historyItems = useAuditHistoryItems({
    historicalEdits,
    timezone,
    shiftThresholds,
    keyPrefix: `${shiftKey}-clockinout`,
    shiftInfo,
  });

  const latestContent = (
    <TimestampRow>
      <AuditTimestampPairDisplay
        edit={latestEdit}
        timezone={timezone}
        shiftThresholds={shiftThresholds}
        shiftKey={`${shiftKey}-clockinout-latest`}
        isHistoricalDeleted={false}
        shiftInfo={shiftInfo}
      />
    </TimestampRow>
  );

  return (
    <AuditSection
      icon={clockInOutIcon}
      iconAlt="Clock in and out"
      title="Clock in and Clock out"
      label={getEditLabel(latestEdit)}
      date={getEditDate(latestEdit)}
      author={getEditAuthor(latestEdit)}
      latestContent={latestContent}
      historyItems={historyItems}
    />
  );
};
